// src/client/dev/register.ts
function registerSW(_options = {}) {
  return async (_reloadPage = true) => {
  };
}
export {
  registerSW
};
